// extracted by mini-css-extract-plugin
export default {"container":"MainContent_container__VGIq1","disabled":"MainContent_disabled__wH8WJ"};